<app-progress id="progreso" [porcentajeSubida]="avance" [mensjeCompletado]="mensajeCompletado" [mensjeProgreso]="mensajeProcesando" (linkClicked)="iraDetalle()"></app-progress>
